import { createContext, MouseEvent } from 'react';
import { ScrollAnchorRef } from './types';

export type OQAATProviderContext = {
  /** registered anchor refs */
  anchors: ScrollAnchorRef[];
  /** currently active anchor */
  activeAnchor: ScrollAnchorRef | null;
  /** activate next anchor */
  nextQuestion(e: MouseEvent): void;
  /** helper function to anchor ref */
  scrollTo(ref: ScrollAnchorRef): void;
  /** register an anchor ref */
  register(payload: ScrollAnchorRef): void;
  /** unregiter an anchor ref */
  unregister(payload: ScrollAnchorRef): void;
};

const Context = createContext<OQAATProviderContext>({} as OQAATProviderContext);

export default Context;
